import { IBaseAction, IBaseState, TAppError } from '@/store/types/base.state';

import { IState } from '@/store/types/search.types';

import { IUser } from '@/features/user/store/user.model';

export enum UserActionTypes {
  UPDATE_USER = 'PROFILE.UPDATE_USER',
  UPDATE_USER_SUCCESS = 'PROFILE.UPDATE_USER_SUCCESS',
  UPDATE_USER_FAIL = 'PROFILE.UPDATE_USER_FAIL',

  REFRESH_USER = 'PROFILE.REFRESH_USER',
  REFRESH_USER_SUCCESS = 'PROFILE.REFRESH_USER_SUCCESS',
  REFRESH_USER_FAIL = 'PROFILE.REFRESH_USER_FAIL',

  CREATE_USER = 'PROFILE.CREATE_USER',
  CREATE_USER_SUCCESS = 'PROFILE.CREATE_USER_SUCCESS',
  CREATE_USER_FAIL = 'PROFILE.CREATE_USER_FAIL',

  DEACTIVATE_USER = 'PROFILE.DEACTIVATE_USER',
  DEACTIVATE_USER_SUCCESS = 'PROFILE.DEACTIVATE_USER_SUCCESS',
  DEACTIVATE_USER_FAIL = 'PROFILE.DEACTIVATE_USER_FAIL',

  SEND_FORGOT_PASSWORD = 'PROFILE.SEND_FORGOT_PASSWORD',
  SEND_FORGOT_PASSWORD_SUCCESS = 'PROFILE.SEND_FORGOT_PASSWORD_SUCCESS',
  SEND_FORGOT_PASSWORD_FAIL = 'PROFILE.SEND_FORGOT_PASSWORD_FAIL',
}

export interface IUpdateUserAction extends IBaseAction {
  type: typeof UserActionTypes.UPDATE_USER;
  userId: number;
}

export interface IUpdateUserSuccessAction extends IBaseAction {
  type: typeof UserActionTypes.UPDATE_USER_SUCCESS;
  user: IUser;
}

export interface IUpdateUserFailAction extends IBaseAction {
  type: typeof UserActionTypes.UPDATE_USER_FAIL;
  userId: number;
  error: TAppError;
}

export interface IRefreshUserAction extends IBaseAction {
  type: typeof UserActionTypes.REFRESH_USER;
  userId: number;
}

export interface IRefreshUserSuccessAction extends IBaseAction {
  type: typeof UserActionTypes.REFRESH_USER_SUCCESS;
  user: IUser;
}

export interface IRefreshUserFailAction extends IBaseAction {
  type: typeof UserActionTypes.REFRESH_USER_FAIL;
  userId: number;
  error: TAppError;
}

export interface ICreateUserAction extends IBaseAction {
  type: typeof UserActionTypes.CREATE_USER;
}

export interface ICreateUserSuccessAction extends IBaseAction {
  type: typeof UserActionTypes.CREATE_USER_SUCCESS;
  user: IUser;
}

export interface ICreateUserFailAction extends IBaseAction {
  type: typeof UserActionTypes.CREATE_USER_FAIL;
  error: TAppError;
}

export interface IDeactivateUserAction extends IBaseAction {
  type: typeof UserActionTypes.DEACTIVATE_USER;
  userId: number;
}

export interface IDeactivateUserSuccessAction extends IBaseAction {
  type: typeof UserActionTypes.DEACTIVATE_USER_SUCCESS;
  user: IUser;
}

export interface IDeactivateUserFailAction extends IBaseAction {
  type: typeof UserActionTypes.DEACTIVATE_USER_FAIL;
  error: TAppError;
  userId: number;
}

export interface ISendForgotPasswordAction extends IBaseAction {
  type: typeof UserActionTypes.SEND_FORGOT_PASSWORD;
  userId: number;
}

export interface ISendForgotPasswordSuccessAction extends IBaseAction {
  type: typeof UserActionTypes.SEND_FORGOT_PASSWORD_SUCCESS;
  userId: number;
}

export interface ISendForgotPasswordFailAction extends IBaseAction {
  type: typeof UserActionTypes.SEND_FORGOT_PASSWORD_FAIL;
  userId: number;
  error: TAppError;
}

export type TUserAction =
  | IUpdateUserAction
  | IUpdateUserSuccessAction
  | IUpdateUserFailAction
  | IRefreshUserAction
  | IRefreshUserSuccessAction
  | IRefreshUserFailAction
  | IDeactivateUserAction
  | IDeactivateUserSuccessAction
  | IDeactivateUserFailAction
  | ICreateUserAction
  | ICreateUserSuccessAction
  | ICreateUserFailAction
  | ISendForgotPasswordAction
  | ISendForgotPasswordSuccessAction
  | ISendForgotPasswordFailAction;

export interface IUserState extends IBaseState {
  user: IState<IUser>;
}
